import { Map } from "immutable";

import actionTypes from "../../../action-types";
import { ContentModule } from "../../../models/state/modules/Modules";
import { Word, Words } from "../../../models/state/words/Words";

export default function wordsReducer(
  words: Words = Map<string, Word>(),
  action: Record<string, any>
): Words {
  switch (action.type) {
    case actionTypes.ADD_WORD: {
      const { modules, ...word } = action.payload.word;

      return words.set(word.id, {
        ...word,
        moduleIds: modules.map((module: ContentModule) => module.id)
      });
    }

    default:
      return words;
  }
}
